import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTooltipCaretDirective } from './mat-tooltip-caret.directive';
import { IsEllipsisActiveDirective } from './is-ellipsis-active.directive';



@NgModule({
  declarations: [
    MatTooltipCaretDirective,
    IsEllipsisActiveDirective
  ],
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  exports: [
    MatTooltipModule,
    MatTooltipCaretDirective,
    IsEllipsisActiveDirective
  ]
})
export class DkuMatTooltipModule { }
